var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"block":"","color":"light-blue","dark":"","large":""},on:{"click":function($event){return _vm.authenticate('vsc')}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("storage")]),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }